export default __webpack_public_path__ + "static/media/img-0523-norway-full-face.d8271be1.png";